import { DynamicLoaderRegistry } from '@tencent/workbench';
import { loadTask } from '@framework/workbench/common/service/tasks/load-task';
import type { IBaseDrawerFeature } from '@src/framework/workbench/common/feature/base-drawer-interface';
import type { IRotation3D } from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/element-model-props.interface';
import type { MaterialType, CameraPresetType } from '@tencent/docs-renderer-3d';
import { ITDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';

export interface ISelectOption {
    key: string;
    content: React.ReactChild;
}

export interface IThreeDFeature extends IBaseDrawerFeature {
    readonly rotation3D: IRotation3D | undefined;
    readonly depth3D: number | undefined;
    readonly depthColor: ITDColor | undefined;
    readonly isFlatText: boolean | undefined;
    readonly frontFrustumInfo: IFrustumInfo | undefined;
    readonly backFrustumInfo: IFrustumInfo | undefined;
    readonly lightType: { key: string, content: string };
    readonly lightTypeOptions: ISelectOption[];
    readonly cameraTypeOptions: ISelectOption[];
    readonly materialTypeOptions: ISelectOption[];
    readonly lightRotationAngle: number;
    readonly materialType: MaterialType | undefined;
    readonly cameraPreset: CameraPresetType | undefined;
    shouldDisable3D(): boolean;
    shouldDisableComplex3DProperties(): boolean;
    shouldDisableShowFlatText(): boolean;
    reset3d(): void;
    handleRotation3DChange(rotation3D: IRotation3D): void;
    handleDepth3DChange(value: number): void;
    handleDepthColorChange(color: ITDColor): void;
    handleShowFlatTextChange(isFlatText: boolean): void;
    handleFrustumChange(change: IFrontAndBackFrustumUpdateInfo): void;
    handleLightTypeChange(lightType: string): void;
    handleLightRotationAngleChange(angle: number): void;
    handleMaterialTypeChange(materialType: MaterialType): void;
    handleCameraPresetChange(cameraPreset: CameraPresetType): void;
    getColorSelectButton(): JSX.Element;
    renderReset3d(): JSX.Element;
}

export const IThreeDFeature = Symbol.for('feature:drawer-3d');

DynamicLoaderRegistry.merge(IThreeDFeature, {
    useFactory: async () => {
        const { ThreeDFeature } = await import('./three-d-feature');
        return ThreeDFeature;
    },
    on: loadTask,
});

export interface IFrustumInfo {
    width: number;
    height: number;
}

export interface IFrontAndBackFrustumUpdateInfo {
    front?: Partial<IFrustumInfo>;
    back?: Partial<IFrustumInfo>;
}
